"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var recommendation_service_1 = require("../../service/recommendation-service");
var column_view_model_1 = require("../model/column-view.model");
var column_highlight_event_1 = require("../model/event/column-highlight-event");
var columns_change_event_1 = require("../model/event/columns-change-event");
var columns_change_event_type_1 = require("../model/event/columns-change-event-type");
var rows_change_event_type_1 = require("../model/event/rows-change-event-type");
var report_table_view_model_1 = require("../model/report-table-view.model");
var table_options_1 = require("../model/table-options");
var branch_index_regulator_1 = require("../service/branch-index-regulator");
var dataset_container_1 = require("../service/dataset-container");
var view_event_service_1 = require("../service/view-event.service");
var headcell_drag_and_drop_manager_1 = require("./service/headcell-drag-and-drop-manager");
var report_tree_to_table_parser_1 = require("./service/report-tree-to-table-parser");
var table_view_manager_1 = require("./service/table-view-manager");
var tree_view_manager_1 = require("./service/tree-view-manager");
var SisTabularReportTableHeaderComponent = /** @class */ (function () {
    function SisTabularReportTableHeaderComponent(applicationPropertiesService, datasetContainer, viewEventService, predictionService, changeDetectorRef) {
        var _this = this;
        this.applicationPropertiesService = applicationPropertiesService;
        this.datasetContainer = datasetContainer;
        this.viewEventService = viewEventService;
        this.predictionService = predictionService;
        this.changeDetectorRef = changeDetectorRef;
        this._groupedPathItems = new Map();
        this._subscriptions = [];
        this._branchIndexRegulator = new branch_index_regulator_1.BranchIndexRegulator();
        this._dndManager = new headcell_drag_and_drop_manager_1.HeadCellDragAndDropManager(function () { return _this.reportTableView.columns; }, this._table, this.viewEventService);
    }
    SisTabularReportTableHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.dataSetId) {
            this._subscriptions.push(this.datasetContainer.getGroupedPaths(this.dataSetId).subscribe(function (paths) {
                _this._groupedPathItems = paths;
                _this._allPaths = new Map();
                Array.from(paths.values()).forEach(function (groupPaths) {
                    groupPaths.forEach(function (path) { return _this._allPaths.set(path.id, path); });
                });
            }));
            this._subscriptions.push(this.viewEventService.rowsChange$.subscribe(function (event) { return _this.onRowsChange(event); }));
            this._subscriptions.push(this.viewEventService.rowElementSelected$.subscribe(function (data) {
                _this.reportTableView.columns.clean();
                _this._table.disableRowsAnimation();
                _this.redraw(_this._table.options);
                _this._dndManager.tableChangeInput.next(_this._table);
                // send event on table columns depth changed
                _this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(_this._table.columnsDepth));
            }));
            this._subscriptions.push(this._dndManager.tableChangeOutput.asObservable().subscribe(function (t) {
                _this._table = t;
                _this.changeDetectorRef.markForCheck();
            }));
            this._subscriptions.push(this.viewEventService.styleChange$.subscribe(function () {
                _this._table.disableRowsAnimation();
                _this.redraw(_this._table.options);
            }));
        }
    };
    SisTabularReportTableHeaderComponent.prototype.ngOnDestroy = function () {
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
        this._dndManager.destroy();
    };
    SisTabularReportTableHeaderComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes['reportTableView']) {
            // add default new btn in the end of table header
            this.reportTableView.columns.add(new column_view_model_1.ColumnView(null, false, false, true));
            // create table from columns tree
            var options = new table_options_1.TableOptions().setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
            this.redraw(options);
            this._dndManager.tableChangeInput.next(this._table);
            // send event on table columns depth changed
            this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this._table.columnsDepth, this.getCurrentBranchIndexesDifference(this.reportTableView.columns)));
        }
    };
    Object.defineProperty(SisTabularReportTableHeaderComponent.prototype, "table", {
        get: function () {
            return this._table;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportTableHeaderComponent.prototype, "dndManager", {
        get: function () {
            return this._dndManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportTableHeaderComponent.prototype, "groupedPathItems", {
        get: function () {
            return this._groupedPathItems;
        },
        enumerable: true,
        configurable: true
    });
    SisTabularReportTableHeaderComponent.prototype.onRowsChange = function (event) {
        // in highlight / unhighlight event case do not redraw whole table, just fill options in body
        if (event.type === rows_change_event_type_1.RowsChangeEventType.ROW_HIGHLIGHTED || event.type === rows_change_event_type_1.RowsChangeEventType.ROW_UNHIGHLIGHTED) {
            table_view_manager_1.TableViewManager.fillTableBodyHighlightedOptions(this._table.body, event.options);
            return;
        }
        // otherwise clean tree and redraw table
        this.reportTableView.columns.cleanRemovedNodes();
        this.reportTableView.columns.recalculateIndexes();
        this.reportTableView.columns.cleanAnimatedFlags();
        if (event.type === rows_change_event_type_1.RowsChangeEventType.ROW_CREATED) {
            this.reportTableView.columns.clean();
        }
        this.redraw(event.options);
        this._dndManager.tableChangeInput.next(this._table);
        // send event on table columns depth changed
        this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this._table.columnsDepth));
    };
    SisTabularReportTableHeaderComponent.prototype.onBodyClick = function () {
        this.reportTableView.columns.clean();
        // parse column tree view to table element
        var options = this._table.options;
        options.options.forEach(function (value) { return value.animate = false; });
        this.redraw(options);
        this._dndManager.tableChangeInput.next(this._table);
        // send event on table columns depth changed
        this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this._table.columnsDepth));
        // send event on element selected
        this.viewEventService.resetColumnElementSelection();
    };
    SisTabularReportTableHeaderComponent.prototype.addNode = function (pathDto, cell) {
        if (pathDto instanceof idm_dataset_service_client_js_1.CategoryPathDto) {
            tree_view_manager_1.TreeViewManager.replaceCategoryNode(pathDto, cell.node);
        }
        else {
            tree_view_manager_1.TreeViewManager.replaceMeasureNode(pathDto, cell.node);
        }
        this.redraw(this._table.options);
        this._dndManager.tableChangeInput.next(this._table);
        // send event on table columns depth changed
        this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this._table.columnsDepth, this.getCurrentBranchIndexesDifference(this.reportTableView.columns), columns_change_event_type_1.ColumnsChangeEventType.COLUMN_ADDED));
    };
    SisTabularReportTableHeaderComponent.prototype.highlight = function (node, value) {
        this._table.disableRowsAnimation();
        node.isHighlighted = value;
        this.viewEventService.columnHighlighted(new column_highlight_event_1.ColumnHighlightEvent(value));
    };
    SisTabularReportTableHeaderComponent.prototype.selectNode = function (node) {
        if (node.isSelected) {
            // to replace current node element
            node.isGoingToReplace = true;
        }
        if (node.isNew || node.isDefaultNew || node.isGoingToReplace) {
            this.reportTableView.columns.cleanSelectedFlags();
            node.isSelected = true;
            if (node.isDefaultNew) {
                this._branchIndexRegulator.calculateAndStoreBranchIndexes(this.reportTableView.columns, 'columnBranchIndexBefore');
            }
            if (this.selectMenu) { // Due to ngIf, selectMenu may not initialized yet
                this.selectMenu.open();
                this.viewEventService.resetColumnElementSelection();
            }
        }
        else {
            this.reportTableView.columns.clean();
            this.redraw(this._table.options);
            this._dndManager.tableChangeInput.next(this._table);
            node.isSelected = true;
            // send event on element selected
            var path = void 0;
            if (node.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                path = this._allPaths.get(node.element.measurePathHolderId);
            }
            else if (node.element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                path = this._allPaths.get(node.element.categoryElementDto.categoryPathHolderId);
            }
            this.viewEventService.columnElementSelected(node, path);
            // send event on table columns depth changed
            this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this._table.columnsDepth));
        }
    };
    SisTabularReportTableHeaderComponent.prototype.addTempNodes = function (node) {
        this._branchIndexRegulator.calculateAndStoreBranchIndexes(this.reportTableView.columns, 'columnBranchIndexBefore');
        this.reportTableView.columns.cleanSelectedFlags();
        this.viewEventService.resetColumnElementSelection();
        // add temporary new nodes
        tree_view_manager_1.TreeViewManager.addTempNodes(node);
        // parse column tree view to table element
        this.redraw(this._table.options);
        this._dndManager.tableChangeInput.next(this._table);
        // send event on table columns depth changed
        this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this._table.columnsDepth, this.getCurrentBranchIndexesDifference(this.reportTableView.columns), columns_change_event_type_1.ColumnsChangeEventType.TEMP_COLUMNS_ADDED));
    };
    SisTabularReportTableHeaderComponent.prototype.remove = function (event, columnView, removeSubTree) {
        event.stopPropagation();
        tree_view_manager_1.TreeViewManager.removeNode(columnView, removeSubTree);
        this.redraw(this._table.options);
        this._dndManager.tableChangeInput.next(this._table);
        // clean tree after animation done
        this.cleanRemovedNodesAfterAnimationDone(columnView, removeSubTree);
    };
    SisTabularReportTableHeaderComponent.prototype.highlightRemove = function (columnView, removeSubTree) {
        this.reportTableView.columns.cleanGoingToRemoveFlags();
        columnView.isGoingToRemove = true;
        if (removeSubTree) {
            columnView.setGoingToRemoveFlags();
        }
    };
    SisTabularReportTableHeaderComponent.prototype.unHighlightRemove = function () {
        this.reportTableView.columns.cleanGoingToRemoveFlags();
    };
    SisTabularReportTableHeaderComponent.prototype.redraw = function (options) {
        var isLastRowContainsOnlyTempNode = this.isLastRowContainsOnlyTempNode();
        var columnsDepth = this._table ? this._table.columnsDepth : 0;
        this._table = report_tree_to_table_parser_1.ReportTreeToTableParser.parse(this.reportTableView.columns, options);
        this._table.lastRowTempNodeRemoved =
            (isLastRowContainsOnlyTempNode && !this.isLastRowContainsOnlyTempNode()) && (columnsDepth !== this._table.columnsDepth);
        this.changeDetectorRef.markForCheck();
    };
    /**
     * Method clean removed nodes from tree and redraw table after animation done.
     * We set timeout for sure animation is done.
     * The algorithm set several flags to smooth animate table rows.
     * 1. when removed node has children and these child nodes not removed we set 'parent-removed' flag set on child elements of removed node.
     * 2. when subtree is removed we set 'child-removed' flag on table head's last row to animate table head, we calculate table head shift
     * (difference of rows count in table head after and before elements removal), and set class on last row using this number.
     * @param {ColumnView} node
     * @param {boolean} removeSubTree
     */
    SisTabularReportTableHeaderComponent.prototype.cleanRemovedNodesAfterAnimationDone = function (node, removeSubTree) {
        var self = this;
        setTimeout(function () {
            self._branchIndexRegulator.calculateAndStoreBranchIndexes(self.reportTableView.columns, 'columnBranchIndexBefore');
            var childRemoved = true;
            var prevDepth = self._table.head.length;
            // clean tree animated flags included parent/child removed flags
            self.reportTableView.columns.cleanAnimatedFlags();
            // set parent/child removed flags
            if (node.children.length > 0 && !removeSubTree) {
                childRemoved = false;
                for (var i = 0; i < node.children.length; i++) {
                    node.children[i].isParentRemoved = true;
                }
            }
            // clean tree and redraw table
            self.reportTableView.columns.cleanRemovedNodes();
            self.reportTableView.columns.recalculateIndexes();
            // parse new table and redraw
            self.redraw(self._table.options);
            self._dndManager.tableChangeInput.next(self._table);
            // if child removed, calculate table head's rows change to animate table head
            if (childRemoved) {
                self._table.headShift = self._table.head.length - prevDepth;
            }
            // send event on table columns depth changed
            self.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(self._table.columnsDepth, self.getCurrentBranchIndexesDifference(self.reportTableView.columns), columns_change_event_type_1.ColumnsChangeEventType.COLUMN_REMOVED));
        }, 262);
    };
    SisTabularReportTableHeaderComponent.prototype.getCurrentBranchIndexesDifference = function (tree) {
        var branchIndexesDif = new Map();
        this._branchIndexRegulator.calculateAndStoreBranchIndexes(tree, 'columnBranchIndexAfter');
        this._branchIndexRegulator.constructDifferenceMap(branchIndexesDif, tree, 'columnBranchIndexBefore', 'columnBranchIndexAfter');
        return branchIndexesDif;
    };
    SisTabularReportTableHeaderComponent.prototype.isLastRowContainsOnlyTempNode = function () {
        if (!this._table) {
            return false;
        }
        var lastRow = this._table.head[this._table.head.length - 1];
        return lastRow.length === 1 && lastRow[0].node.isNew;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", report_table_view_model_1.ReportTableView)
    ], SisTabularReportTableHeaderComponent.prototype, "reportTableView", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisTabularReportTableHeaderComponent.prototype, "dataSetId", void 0);
    __decorate([
        core_1.ViewChild('columnSelectMenu'),
        __metadata("design:type", idm_ng_controls_1.SisSelectComponent)
    ], SisTabularReportTableHeaderComponent.prototype, "selectMenu", void 0);
    SisTabularReportTableHeaderComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-tabular-report-table-header',
            template: require('./sis-tabular-report-table-header.component.html'),
            styles: [require('./sis-tabular-report-table-header.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService, dataset_container_1.DatasetContainer,
            view_event_service_1.ViewEventService, recommendation_service_1.RecommendationService, core_1.ChangeDetectorRef])
    ], SisTabularReportTableHeaderComponent);
    return SisTabularReportTableHeaderComponent;
}());
exports.SisTabularReportTableHeaderComponent = SisTabularReportTableHeaderComponent;
//# sourceMappingURL=sis-tabular-report-table-header.component.js.map